import { UseBaseQueryOptions } from '@/core/api/type'
import { GetWithdrawalTransactionsByIdResponse } from '@/modules/transaction/types'
import bankTransactionService from '../../services'
import { TransactionQueryKeys } from '@/modules/transaction/keys'

export const queryWithdrawTransactionsByIdOptions = (
	id: string,
	options?: UseBaseQueryOptions<GetWithdrawalTransactionsByIdResponse>,
) => ({
	queryKey: [TransactionQueryKeys.WITHDRAW_TRANSACTION, id],
	queryFn: () => bankTransactionService.getWithdrawalTransactionsById(id),
	...options,
})
